import Glide, { Controls, Keyboard, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
import refs from '../helpers/refs'

class CTrendingProducts {
  constructor (el) {
    this.$root = el
    this.$refs = refs(el)

    if (!this.$refs.slider) {
      return
    }

    setTimeout(() => {
      this.init()
    }, 100)
  }

  init () {
    this.glide = new Glide(this.$refs.slider, {
      dragThreshold: false,
      type: 'slider',
      autoheight: true,
      gap: 32,
      perView: 3,
      bound: true,
      breakpoints: {
        768: {
          perView: 1.1,
          gap: 16
        },
        1024: {
          dragThreshold: 120,
          perView: 2.15,
          gap: 32
        }
      }
    }).mount({ Controls, Keyboard, Breakpoints, Swipe })

    this.glide.on('run', () => {
      this.setControls(this.glide.index)
    })

    this.$refs.controls.forEach((control, i) => {
      control.addEventListener('click', (e) => {
        this.glide.go(`=${i}`)
        this.setControls(i)
      })
    })
  }

  setControls (index) {
    this.$refs.controls.forEach((control, i) => {
      control.classList.toggle('--active', i === index)
    })
  }
}

// Wait for images to load in
window.addEventListener('load', () => {
  document
    .querySelectorAll('.c-trending-products')
    .forEach(el => new CTrendingProducts(el))
})
